"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getCombinedUserNotificationsObject = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCombinedUserNotificationsObject = function getCombinedUserNotificationsObject(previousUserNotificaitons, newUserNotificaitons) {
  var updatedUserNotificaitons = newUserNotificaitons;
  updatedUserNotificaitons.content = previousUserNotificaitons.content.concat(newUserNotificaitons.content).sort(function (a, b) {
    return b.notificationTimestamp - a.notificationTimestamp;
  });
  return updatedUserNotificaitons;
};

exports.getCombinedUserNotificationsObject = getCombinedUserNotificationsObject;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isFetchingUserNotifications: false,
    isEditingUserNotifications: false,
    userNotifications: {
      content: [],
      number: 0,
      size: 0,
      last: true
    },
    unviewedNotificationCount: 0
  };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case types.NOTIFICATIONS_INCREMENT_UNVIEWED_COUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        unviewedNotificationCount: state.unviewedNotificationCount + 1
      });

    case types.NOTIFICATION_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: true
      });

    case types.NOTIFICATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: false,
        userNotifications: action.responseData.data,
        additionalUserNotifications: {},
        unviewedNotificationCount: Number(action.responseData.headers['x-unviewed-count']),
        unreadNotificationCount: Number(action.responseData.headers['x-unread-count'])
      });

    case types.NOTIFICATION_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: false
      });

    case types.NOTIFICATION_PAGE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: true
      });

    case types.NOTIFICATION_PAGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: false,
        userNotifications: getCombinedUserNotificationsObject(state.userNotifications, action.responseData)
      });

    case types.NOTIFICATION_PAGE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserNotifications: false
      });

    case types.NOTIFICATION_EDIT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: true
      });

    case types.NOTIFICATION_EDIT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false
      });

    case types.NOTIFICATION_EDIT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false
      });

    case types.NOTIFICATIONS_MARK_AS_VIEWED_REQUESTED:
      _reactGa["default"].event({
        category: 'Notifications',
        action: 'Mark as viewed',
        value: state.unviewedNotificationCount
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: true,
        unviewedNotificationCount: 0
      });

    case types.NOTIFICATIONS_MARK_AS_VIEWED_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false
      });

    case types.NOTIFICATIONS_MARK_AS_VIEWED_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false
      });

    case types.NOTIFICATIONS_MARK_AS_READ_REQUESTED:
      _reactGa["default"].event({
        category: 'Notifications',
        action: 'Mark as read'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: true
      });

    case types.NOTIFICATIONS_MARK_AS_READ_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false,
        userNotifications: _objectSpread(_objectSpread({}, state.userNotifications), {}, {
          content: state.userNotifications.content.map(function (notification) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              readTimestamp: action.userNotifications.readNotificationsTimestamps.indexOf(notification.notificationTimestamp) !== -1 ? new Date() : notification.readTimestamp
            });
          })
        })
      });

    case types.NOTIFICATIONS_MARK_AS_READ_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingUserNotifications: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;